export const VIDEO_RECORDING_ERRORS = {
  NO_MIMETYPE_SUPPORTED: 'Your device is not supported for video recording',
};
